module.exports = __webpack_public_path__ + "img/C4C-Stacked.ca82c342.png";